
import React from 'react';
import PropTypes from 'prop-types';

const PortionsIcon = ({ className }) => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      className={`fill-current ${className}`}
      xmlns="http://www.w3.org/2000/svg">
        <path d="M1.25 21.8496H23.225" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M2.52539 19.1494C2.92888 16.851 4.12545 14.7667 5.90688 13.2594C7.68832 11.752 9.94186 10.9169 12.2754 10.8994C14.6042 10.9049 16.8553 11.7373 18.6274 13.2484C20.3994 14.7594 21.5771 16.8507 21.9504 19.1494" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M12.2752 10.8248C13.3522 10.8248 14.2252 9.95176 14.2252 8.87481C14.2252 7.79785 13.3522 6.9248 12.2752 6.9248C11.1982 6.9248 10.3252 7.79785 10.3252 8.87481C10.3252 9.95176 11.1982 10.8248 12.2752 10.8248Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M12.2754 1V3.77499" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M6.5 2.875V5.575" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
        <path d="M18.0498 2.875V5.575" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
    </svg>
  );
};

PortionsIcon.propTypes = {
  className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

PortionsIcon.defaultProps = {
  className: '', // Default to an empty string
};

export default PortionsIcon;